import { Virtualizer } from '@tanstack/react-virtual';
import { ConversationMessageView } from '@mark43/cad-api';
import { useLayoutEffect } from 'react';
import { ConversationMetadata } from '../store/types';

export const useScrollToMessage = (
    messageRowVirtualizer: Virtualizer<HTMLDivElement, Element>,
    selectedConversationMessages?: ConversationMessageView[],
    conversationMetadata?: ConversationMetadata
) => {
    const areMessagesFetched = selectedConversationMessages === undefined;

    // this useLayoutEffect causes the message list to scroll to a message after the list has been rendered. It is used to scroll the list to the bottom when selecting a new conversations, or to
    // a message that the user has just added.
    useLayoutEffect(() => {
        if (selectedConversationMessages !== undefined && conversationMetadata !== undefined) {
            const { scrollToMessageIndex } = conversationMetadata;
            const lastMessageIndex = selectedConversationMessages.length - 1;

            // * There is an out-of-order issue which causes useScrollToMessage() to try to scroll to an invalid index when
            //   switching from a smaller conversation to a bigger conversation.
            //
            // * The problem is that scrollToMessageIndex is set before the message rows are updated in the messageRowVirtualizer,
            //   and so the hook called scrollToIndex() too soon
            //
            // * The issue was invisible since the hooks re-executes shortly afterwards, when the arrays are in sync.
            //
            // * Re-ordering these operations isn't straight forward, so a simple solution has been used to avoid the problem
            //   which is to bypass calling scrollToIndex() if the scrollToMessageIndex is greater than lastMessageIndex.

            if (
                scrollToMessageIndex !== undefined &&
                messageRowVirtualizer.getVirtualItems().length > 0 &&
                scrollToMessageIndex <= lastMessageIndex
            ) {
                messageRowVirtualizer.scrollToIndex(scrollToMessageIndex, {
                    align: 'start',
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        conversationMetadata?.scrollToMessageIndex,
        areMessagesFetched,
        selectedConversationMessages,
    ]);
};
